import React from "react";
import { withStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";

import SnetSvgLogo from "shared/dist/components/SnetSvgLogo";
import { useStyles } from "./styles";

const RegistrationHeader = ({ classes, headerTitle, headerLinkText, headerLinkTo }) => {
    return (
        <Box className={classes.registrationHeaderContainer}>
            <Box className={classes.logoContainer}>
                <h1>
                    <Link to="">
                        <SnetSvgLogo />
                    </Link>
                </h1>
            </Box>
            {headerLinkTo && (
                <Box className={classes.headerLink}>
                    <span>{headerTitle} &nbsp;</span>
                    <Link to={headerLinkTo}>{headerLinkText}</Link>
                </Box>
            )}
        </Box>
    );
};

export default withStyles(useStyles)(RegistrationHeader);
